const mainPageVideoSection = document.querySelector('.main-page-video-section');

if (mainPageVideoSection) {
    if (mainPageVideoSection.dataset.customerLogged !== 'true') {
        window.addEventListener('load', () => {
            // (Temporary?) hack to wait for API call to load video elements on /pages/bt-livestream-video-gallery (and elsewhere?)
            setTimeout(() => {
                attachLoginRedirects();
            }, 500);
        });
    }
} else {
    attachLoginRedirects();
}


function attachLoginRedirects() {
    const loginRedirectBtns = document.querySelectorAll('a.btn-login');
    if (loginRedirectBtns) {
        loginRedirectBtns.forEach((btn) => {
            let href = btn.href;
            href = `${href}?redirect=${window.location.href}`;
            btn.href = href;
        });
    }
}